<template>
  <div class="home-collaborate-tab ml-auto mr-auto">
    <v-progress-circular
      v-if="isCordLoading"
      class="mt-8"
      indeterminate
      color="brandPrimary"
      size="40"
    />
    <div
      v-else
      style="height: 100%;"
    >
      <cord-notification-list
        max-count="10"
        fetch-additional-count="3"
        class="notification-list"
        @cord-notification:click="onNotificationClick"
        @click.prevent
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import { useCommenting } from '@/stores/commenting/commenting';

export default {
  name: 'HomeCollaborateTab',
  computed: {
    isCordLoading() {
      return useCommenting().isCordLoading;
    },
  },

  mounted() {
    return this.loadCord();
  },

  methods: {
    ...mapActions(useCommenting, ['loadCord', 'setCordLoading']),

    onNotificationClick({ detail: [, { location = {} }] }) {
      const { page, ...params } = location;
      const newRoute = { name: page, params };

      if (page === 'requisition-report') {
        newRoute.query = { showComments: true };
      }

      if (page === 'editor') {
        newRoute.name = 'editor-view';
      }

      this.setCordLoading(true);
      this.$router.push(newRoute);
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/less/cord';

.home-collaborate-tab {
  .cord-common-styles();
  .cord-message-styles();

  height: calc(100% - 2px);

  :deep(cord-notification-list) {
    box-shadow: none !important;
    height: calc(100% - 2px);

    // move notification list header to the bottom of notification list
    .cord-notification-list-container {
      flex-direction: column-reverse;
      height: auto;
      max-height: 100%;
    }

    // hide "Notifications" label
    .cord-notification-list-header > p {
      display: none;
    }

    .cord-scroll-container {
      padding: 12px 0 0 0;
    }

    .cord-notification-icon-container {
      // TODO: tell Cord maintainers they forgot grid-area
      grid-area: icon;
      display: none;
    }

    .cord-notification-container {
      grid-template-columns: 1fr auto;
      grid-template-areas:
        "header       menu"
        "content      content"
        "timestamp    timestamp";

      // align notification text with the collaborate icon above
      padding-left: 16px;

      &.cord-unseen:before {
        opacity: 0.1;
      }
    }

    .cord-empty-state-placeholder-with-icon {
      margin: 0 0;
    }
  }

  .notification-list {
    margin-top: 2px;
    text-align: initial;
    border: none;
  }
}
</style>
